// import { isProd } from 'helpers/helper_functions';
// export const FEATURE_FLAG_ENABLED_BREADCRUMB = isProd() ? false : true;

export const FEATURE_FLAG_ENABLED_BREADCRUMB = true;
